import styled from 'styled-components';

export const AuthPanel = styled.section`
  width: 100%;
  /* max-width: 28rem; */

  display: flex;
  flex-direction: column;
  gap: var(--space-l);

  padding: var(--space-xl);

  background: var(--white);
  border: 1px solid var(--grey);
  border-radius: var(--space-m);
  box-shadow: var(--shadow-sm);

  @media (max-width: 1000px) {
    max-width: none;
  }
`;

export const AuthHeader = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--space-xs);
`;

export const AuthEyebrow = styled.span`
  color: var(--orange5);

  font-size: 0.7rem;
  font-weight: 700;
  line-height: 1.2;

  letter-spacing: 0.08em;
  text-transform: uppercase;
`;

export const AuthTitle = styled.h2`
  margin: 0;

  color: var(--grey7);

  font-size: 1.35rem;
  font-weight: 700;
  line-height: 1.25;

  letter-spacing: -0.02em;
`;

export const AuthDescription = styled.p`
  margin: 0;

  color: var(--grey4);

  font-size: 0.875rem;
  line-height: 1.5;
`;

export const ModeToggle = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));

  padding: var(--space-xxs);

  background: var(--grey15);
  border: 1px solid var(--grey);
  border-radius: var(--space-xs);
`;

export const ModeButton = styled.button`
  width: 100%;

  padding: var(--space-s) var(--space-m);

  border: 1px solid
    ${({ $active }) => ($active ? 'var(--grey1)' : 'transparent')};
  border-radius: calc(var(--space-xs) - var(--space-xxs));

  background: ${({ $active }) => ($active ? 'var(--white)' : 'transparent')};

  color: ${({ $active }) => ($active ? 'var(--grey7)' : 'var(--grey4)')};

  box-shadow: ${({ $active }) => ($active ? 'var(--shadow-xs)' : 'none')};

  font-family: inherit;
  font-size: 0.85rem;
  font-weight: 700;

  cursor: pointer;

  transition:
    background 0.2s ease,
    color 0.2s ease,
    border-color 0.2s ease,
    box-shadow 0.2s ease;

  &:hover {
    color: var(--grey7);
  }

  &:focus-visible {
    outline: 2px solid var(--orange4);
    outline-offset: var(--space-xxs);
  }
`;

export const FormFields = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--space-m);
`;

export const FieldGroup = styled.div`
  min-width: 0;
  /* border: 2px solid red; */
  display: flex;
  flex-direction: column;
  gap: var(--space-xs);
`;

export const FieldLabel = styled.label`
  color: var(--grey6);

  font-size: 0.8rem;
  font-weight: 700;
  line-height: 1.3;
`;

export const FieldInput = styled.input`
  min-width: 100%;
  /* min-width: 0; */

  padding: var(--space-s) var(--space-m);

  background: var(--white);
  border: 1px solid var(--grey1);
  border-radius: var(--space-xs);

  /* border: 2px sol id orange; */
  color: var(--grey7);

  font: inherit;
  font-size: 0.9rem;

  transition:
    border-color 0.2s ease,
    box-shadow 0.2s ease;

  &::placeholder {
    color: var(--grey2);
  }

  &:hover {
    border-color: var(--grey2);
  }

  &:focus {
    outline: none;

    border-color: var(--orange4);
    box-shadow: 0 0 0 3px var(--orange7);
  }

  &:disabled {
    background: var(--grey15);
    color: var(--grey3);
    cursor: not-allowed;
  }
`;

export const ErrorMessage = styled.div`
  padding: var(--space-s) var(--space-m);

  background: var(--lightRed);
  border: 1px solid var(--errorRed);
  border-radius: var(--space-xs);

  color: var(--errorRed);

  font-size: 0.8rem;
  font-weight: 600;
  line-height: 1.4;
`;

export const CheckoutAction = styled.div`
  padding-top: var(--space-xs);

  & > * {
    width: 100%;
  }
`;

export const PageWrapper = styled.div`
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: calc(var(--space-xl) * 1);
  background: var(--grey18);
`;

export const BackButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: var(--space-xs);
  margin-bottom: var(--space-m);
  background: transparent;
  border: none;
  color: var(--grey6);
  font-weight: 700;
  cursor: pointer;

  &:hover {
    color: var(--grey7);
  }
`;
